import { Component } from '@angular/core';
import { AdminModule } from '../admin.module';

@Component({
  selector: 'app-home-page',
  standalone: true,
  imports: [AdminModule],
  templateUrl: './home-page.component.html',
  styleUrl: './home-page.component.css'
})
export class HomePageComponent {

}
